import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import SuiviInterventionService, { FilterInterventions } from '../services/SuiviInterventionService';
import { SuiviInterventionActions, SuiviInterventionActionTypes } from './action-types';
import { SUIVI_INTERVENTION } from './mutation-types';
import { SuiviInterventionState } from './state';
import axios from 'axios';
import { EQUIPEMENT } from '@/modules/Equipements/store/mutation-types';

let abortController: AbortController | null = null;

export const actions: ActionTree<SuiviInterventionState, RootState> = {
    async [SuiviInterventionActions.GET_SUIVIS_INTERVENTION](
        { commit }: SuiviInterventionActionTypes,
        payload: FilterInterventions
    ) {
        if (abortController) {
            abortController.abort();
        }
        abortController = new AbortController();

        const { isBim, ...params } = payload;
        const serviceParams = params;
        delete (serviceParams as any).isBim;

        if (isBim) {
            commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_PAGE}`, payload.page, { root: true });
            commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_IS_LOADING}`, true, { root: true });
        } else {
            commit(SUIVI_INTERVENTION.SET_PAGE, payload.page);
            commit(SUIVI_INTERVENTION.SET_ERROR, undefined);
            commit(SUIVI_INTERVENTION.SET_IS_LOADING, true);
        }

        try {
            const response = await SuiviInterventionService.getSuiviInterventions(
                serviceParams,
                abortController.signal
            );
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    if (isBim) {
                        commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_ITEMS}`, response.data, {
                            root: true,
                        });
                        commit(
                            `equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_NB_OF_PAGES}`,
                            response.headers.pages,
                            { root: true }
                        );
                        commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_COUNT}`, response.headers.count, {
                            root: true,
                        });
                    } else {
                        commit(SUIVI_INTERVENTION.SET_ITEMS, response.data);
                        commit(SUIVI_INTERVENTION.SET_SCROLL, 0);
                        commit(SUIVI_INTERVENTION.SET_NB_OF_PAGES, response.headers.pages);
                        commit(SUIVI_INTERVENTION.SET_COUNT, response.headers.count);
                    }
                } else {
                    if (isBim) {
                        commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_ADD_ITEMS}`, response.data, {
                            root: true,
                        });
                    } else {
                        commit(SUIVI_INTERVENTION.ADD_ITEMS, response.data);
                    }
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            if (isBim) {
                commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_IS_LOADING}`, false, { root: true });
            } else {
                commit(SUIVI_INTERVENTION.SET_IS_LOADING, false);
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                return;
            }
            if (isBim) {
                commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_IS_LOADING}`, false, { root: true });
            } else {
                commit(SUIVI_INTERVENTION.SET_IS_LOADING, false);
                commit(SUIVI_INTERVENTION.SET_ERROR, error);
            }
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [SuiviInterventionActions.NAV_FILTER]({ commit }: SuiviInterventionActionTypes, etats?: string[]) {
        commit(SUIVI_INTERVENTION.SET_FILTER_STATUS, etats);
    },

    async [SuiviInterventionActions.EXPORT_XLS_INTERVENTIONS](
        { commit }: SuiviInterventionActionTypes,
        payload: FilterInterventions
    ) {
        const { isBim, ...params } = payload;
        const serviceParams = params;
        delete (serviceParams as any).isBim;

        if (isBim) {
            commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_EXPORT_XLS_IS_LOADING}`, true, { root: true });
        } else {
            commit(SUIVI_INTERVENTION.SET_EXPORT_XLS_IS_LOADING, true);
        }

        try {
            const response = await SuiviInterventionService.getExportXlsInterventions(serviceParams);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'export_interventions.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            if (isBim) {
                commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_EXPORT_XLS_IS_LOADING}`, false, {
                    root: true,
                });
            } else {
                commit(SUIVI_INTERVENTION.SET_EXPORT_XLS_IS_LOADING, false);
            }
        } catch (error) {
            if (isBim) {
                commit(`equipementState/${EQUIPEMENT.HISTORIQUE_TRAVAUX_SET_EXPORT_XLS_IS_LOADING}`, false, {
                    root: true,
                });
            } else {
                commit(SUIVI_INTERVENTION.SET_EXPORT_XLS_IS_LOADING, false);
            }
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
